import { ENTER } from "@angular/cdk/keycodes";
import { Component, ElementRef, ViewChild, Input, OnInit } from "@angular/core";
import { MatAutocompleteSelectedEvent } from "@angular/material";
import { Observable } from "rxjs";
import { FormControl, FormGroup } from "@angular/forms";
import { map, startWith } from "rxjs/internal/operators";

@Component({
  selector: "app-chips",
  templateUrl: "./chips.component.html",
  styleUrls: ["./chips.component.css"]
})
export class ChipsComponent implements OnInit {
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  separatorKeysCodes: number[] = [ENTER];
  ctrl = new FormControl();
  filteredList: Observable<any>;

  @ViewChild("input") input: ElementRef<HTMLInputElement>;

  @Input() selectedList: any;
  @Input() list: any;
  @Input() form: FormGroup;

  constructor() {}

  ngOnInit() {}

  remove(fr: string): void {
    const index = this.selectedList.indexOf(fr);
    if (index >= 0) {
      this.list.push(fr);
      this.selectedList.splice(index, 1);
    }
    this.input.nativeElement.value = "";
    this.ctrl.setValue(null);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    var elSelect = event.option.value;
    this.selectedList.push(elSelect);
    const index = this.list.indexOf(elSelect);
    if (index >= 0) {
      this.list.splice(index, 1);
    }
    this.input.nativeElement.blur();
    this.ctrl.setValue(null);
  }

  private _filter(value: any): string[] {
    return this.list.filter(fruit =>
      fruit.Title.toLowerCase().includes(value.Title.toLowerCase())
    );
  }
  loadList() {
    this.filteredList = this.ctrl.valueChanges.pipe(
      startWith(null),
      map((fr: string | null) => (fr ? this._filter(fr) : this.list.slice()))
    );
    this.list = this.list.filter(
      x => !this.selectedList.filter(y => y.Id === x.Id).length
    );
  }
  add(e) {
    console.log(e);

  }
}
